module.exports = "//static.hsappstatic.net/marketplace-unified-public-ui/static-1.2313/img/cms-free-signup.png"